// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0

/**
 * Checks if a file is eligible for direct/fast translation.
 *
 * PDFs: Always eligible (uses Textract + Translate Lambda, up to 20MB)
 * Other formats: Eligible if under 100KB and English is involved
 */
export function isDirectTranslationEligible(
	file: File | undefined,
	sourceLanguage: string,
	targetLanguages: string[],
): boolean {
	if (!file) return false;

	// PDFs always go through the fast path (Textract Lambda handles any size up to 20MB)
	if (file.type === "application/pdf") {
		return file.size <= 20 * 1000 * 1000;
	}

	// Non-PDF: original criteria (under 100KB, English involved)
	const isFileSizeEligible = file.size < 100000;
	const isSourceEnglish = sourceLanguage === "en";
	const isAnyTargetEnglish = targetLanguages.includes("en");

	return isFileSizeEligible && (isSourceEnglish || isAnyTargetEnglish);
}
